import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class Topping extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_flowering_3.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>
        Topping
        </h2>
        <p>
        Topping is the process of purposefully damaging a young plant to increase yield. Plants will naturally have one large stem, or Kola, which will produce the majority of the bud on the plant. To top a marijuana plant you cut the top of your plant main stem just above a node.This can be done with a pair of clean scissors or by even by just plucking the top growth off a node with your fingers. Topping will cause the plant to split into multiple stems, each producing a new kola. You’ll want to top your plants when they are still small and in the vegetative stage. Topping early and often can lead can greatly increase the yield of your grow. There is no downside to topping, so top your plants as many times as you have the opportunity to do so.
        </p>
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/three_topping.js